import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../config/api';
import './RegistrationsPage.css';

export const RegistrationsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadRegistrations();
  }, [filter]);

  const loadRegistrations = async () => {
    try {
      setLoading(true);
      const params = filter === 'all' ? {} : { status: filter };
      const data = await api.get('/api/exchange/admin/registrations/', { params });
      
      setStats(data.stats);
      setRegistrations(data.registrations);
    } catch (error) {
      console.error('Failed to load registrations:', error);
      alert('Kayıtlar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      'pending': 'badge-warning',
      'approved': 'badge-info',
      'rejected': 'badge-danger',
      'admin_created': 'badge-primary',
      'appointment_scheduled': 'badge-success',
      'setup_in_progress': 'badge-info',
      'setup_completed': 'badge-success',
      'cancelled': 'badge-secondary',
    };
    return statusClasses[status] || 'badge-secondary';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'pending': '⏳',
      'approved': '✅',
      'rejected': '❌',
      'admin_created': '👤',
      'appointment_scheduled': '📅',
      'setup_in_progress': '⚙️',
      'setup_completed': '🎉',
      'cancelled': '🚫',
    };
    return icons[status] || '❓';
  };

  const filteredRegistrations = registrations.filter(reg => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      reg.organization_name.toLowerCase().includes(search) ||
      reg.contact_email.toLowerCase().includes(search) ||
      reg.admin_email.toLowerCase().includes(search) ||
      reg.contact_person_name.toLowerCase().includes(search)
    );
  });

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="registrations-page">
        <div className="loading-spinner">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="registrations-page">
      {/* Header */}
      <div className="page-header">
        <div>
          <h1>Kayıt Yönetimi</h1>
          <p className="page-subtitle">Organizasyon kayıtlarını inceleyin ve onaylayın</p>
        </div>
        <button className="btn-refresh" onClick={loadRegistrations}>
          <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
          </svg>
          Yenile
        </button>
      </div>

      {/* Statistics Cards */}
      {stats && (
        <div className="stats-grid">
          <div className="stat-card" onClick={() => setFilter('all')}>
            <div className="stat-icon total">📊</div>
            <div className="stat-info">
              <h3>{stats.total}</h3>
              <p>Toplam Kayıt</p>
            </div>
          </div>

          <div className="stat-card" onClick={() => setFilter('pending')}>
            <div className="stat-icon pending">⏳</div>
            <div className="stat-info">
              <h3>{stats.pending}</h3>
              <p>Onay Bekliyor</p>
            </div>
          </div>

          <div className="stat-card" onClick={() => setFilter('approved')}>
            <div className="stat-icon approved">✅</div>
            <div className="stat-info">
              <h3>{stats.approved}</h3>
              <p>Onaylandı</p>
            </div>
          </div>

          <div className="stat-card" onClick={() => setFilter('appointment_scheduled')}>
            <div className="stat-icon scheduled">📅</div>
            <div className="stat-info">
              <h3>{stats.appointment_scheduled}</h3>
              <p>Randevu Planlandı</p>
            </div>
          </div>

          <div className="stat-card" onClick={() => setFilter('setup_completed')}>
            <div className="stat-icon completed">🎉</div>
            <div className="stat-info">
              <h3>{stats.setup_completed}</h3>
              <p>Tamamlandı</p>
            </div>
          </div>

          <div className="stat-card" onClick={() => setFilter('rejected')}>
            <div className="stat-icon rejected">❌</div>
            <div className="stat-info">
              <h3>{stats.rejected}</h3>
              <p>Reddedildi</p>
            </div>
          </div>
        </div>
      )}

      {/* Filters and Search */}
      <div className="filters-bar">
        <div className="filter-tabs">
          <button 
            className={filter === 'all' ? 'active' : ''} 
            onClick={() => setFilter('all')}
          >
            Tümü ({stats?.total || 0})
          </button>
          <button 
            className={filter === 'pending' ? 'active' : ''} 
            onClick={() => setFilter('pending')}
          >
            Bekleyen ({stats?.pending || 0})
          </button>
          <button 
            className={filter === 'approved' ? 'active' : ''} 
            onClick={() => setFilter('approved')}
          >
            Onaylanan ({stats?.approved || 0})
          </button>
          <button 
            className={filter === 'appointment_scheduled' ? 'active' : ''} 
            onClick={() => setFilter('appointment_scheduled')}
          >
            Randevulu ({stats?.appointment_scheduled || 0})
          </button>
        </div>

        <div className="search-box">
          <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
          </svg>
          <input 
            type="text"
            placeholder="Organizasyon, email veya kişi ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Registrations Table */}
      <div className="table-container">
        {filteredRegistrations.length === 0 ? (
          <div className="empty-state">
            <svg width="64" height="64" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
            </svg>
            <p>Kayıt bulunamadı</p>
          </div>
        ) : (
          <table className="registrations-table">
            <thead>
              <tr>
                <th>Organizasyon</th>
                <th>İletişim Bilgileri</th>
                <th>Admin</th>
                <th>Durum</th>
                <th>Kayıt Tarihi</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredRegistrations.map(reg => (
                <tr key={reg.id} onClick={() => navigate(`/admin/registrations/${reg.id}`)}>
                  <td>
                    <div className="org-cell">
                      <strong>{reg.organization_name}</strong>
                      <span className="domain">{reg.sender_domain}</span>
                    </div>
                  </td>
                  <td>
                    <div className="contact-cell">
                      <span>{reg.contact_person_name}</span>
                      <span className="email">{reg.contact_email}</span>
                      <span className="phone">{reg.contact_phone}</span>
                    </div>
                  </td>
                  <td>
                    <div className="admin-cell">
                      <span>{reg.admin_first_name} {reg.admin_last_name}</span>
                      <span className="email">{reg.admin_email}</span>
                    </div>
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusBadgeClass(reg.status)}`}>
                      {getStatusIcon(reg.status)} {reg.status_display}
                    </span>
                  </td>
                  <td>{formatDate(reg.created_at)}</td>
                  <td>
                    <button 
                      className="btn-view"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/admin/registrations/${reg.id}`);
                      }}
                    >
                      Detay
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default RegistrationsPage;
